import { getCurrencyOption } from '@/lib/currency/currencyOptionsKeys'
import { formatMoney } from "@/lib/money"

// Format currency amount
export const formatPrice = (currencyOptions: Record<string, { amount: number }> | undefined, currency = 'USD') => {
    if (!currencyOptions || Object.keys(currencyOptions).length === 0) {
        return formatMoney(0, currency)
    }

    const resolved = getCurrencyOption(currencyOptions, currency)
    if (!resolved) return formatMoney(0, currency)

    return formatMoney(resolved.option.amount, resolved.currency)
}

// Format billing interval
export const formatBillingInterval = (recurring: boolean, interval: string | null, count: number | null) => {
    if (!recurring || !interval) return 'One-time'
    const intervalText = count && count > 1 ? `${count} ${interval}s` : interval
    return `Every ${intervalText}`
}
